import * as React from 'react';

function Athletics(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.944 6.38l4.282 4.282a6.056 6.056 0 01-8.43 8.695l-.135-.131-.534-.535 1.07-1.07.536.535a4.541 4.541 0 006.54-6.301l-.118-.123-4.282-4.282 1.07-1.07h.001zm-1.74 1.739l4.013 4.015a3.406 3.406 0 01-4.7 4.928l-.116-.11-.267-.268 1.07-1.07.267.266a1.893 1.893 0 002.762-2.585l-.086-.09-4.014-4.016 1.07-1.07zm-3.747 1.07a.757.757 0 011.005-.058l.066.058 4.282 4.282a.757.757 0 01-1.004 1.13l-.067-.059-4.282-4.282a.757.757 0 010-1.07zM4.774 4.774a6.056 6.056 0 018.429-.132l.135.132.535.535-1.07 1.07-.535-.535a4.542 4.542 0 00-6.542 6.3l.118.123 4.283 4.283-1.07 1.07-4.283-4.282a6.056 6.056 0 010-8.564zm2.275 2.007a3.406 3.406 0 014.702-.11l.116.11.267.268-1.07 1.07-.268-.267a1.892 1.892 0 00-2.761 2.585l.085.09 4.015 4.016-1.07 1.07-4.016-4.015a3.406 3.406 0 010-4.817z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Athletics;
